import { Inject, Injectable } from '@angular/core';

@Injectable()
// tslint:disable: max-line-length
export class UrlService {

  environment;

  constructor(@Inject('env') private envConfig) {
    this.environment = this.envConfig.callback(this.envConfig.value);
  }

  public checkTanByTanValue(tanValue: number): string {
    return `${this.environment.classicServiceUrl}api/public/tan/check-tan/${tanValue}`;
  }

  public getBookingMappingByTanValueAndUsername(tanValue: number, username: string): string {
    return `${this.environment.onsetServiceUrl}api/booking-mapping?mapping-id=${tanValue}&context=GAST_LEGACY_TAN&username=${username}`;
  }

  public createBookingMapping(): string {
    return `${this.environment.onsetServiceUrl}api/booking-mapping`;
  }

  public createGastBookingForOnsetStudy(): string {
    return `${this.environment.bookingServiceUrl}api/onset/study-booking/me`;
  }

  public checkIfAlreadyEnoughParticipantForMobileVersion(): string {
    return `${this.environment.onsetServiceUrl}api/booking-mapping/booking/onset-study/check-participants-mobile`;
  }

  public createOnsetBookingForOnsetStudy(username: string): string {
    return `${this.environment.onsetServiceUrl}api/booking-mapping/booking/onset-study?username=${username}`;
  }

  public onSETPortalExamUrl(): string {
    return `${this.environment.onsetPortalExamUrl}`;
  }
}
